module.exports = __webpack_public_path__ + "static/media/IMG-30.77cebf26.jpg";